import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';

const initialValues = {
  password: '',
};

const schema = Yup.object().shape({
  password: capsuleValidation.password(),
});

const validation = {
  initialValues,
  schema,
};

export default validation;
